import * as Clipboard from "expo-clipboard";

import {
  ActivityIndicator,
  Linking,
  Pressable,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import {
  FIREBASE_EVENT_NAMES,
  FIREBASE_EVENT_PARAMS,
  ORDER_STATUS,
  PAGES_ROUTES,
  PAGES_TITLE,
} from "utils/Constants";
import React, { useCallback, useEffect, useRef, useState } from "react";
import Svg, { ClipPath, Defs, G, Path, Rect } from "react-native-svg";
import { fp, hp, spH, spV, wp } from "utils/normalizeV2";
import {
  getFormatedCurrency,
  getOrderHistoryCardBottomView,
  getOrderHistoryCardView,
} from "utils/common";
import { router, useLocalSearchParams } from "expo-router";
import { useDispatch, useSelector } from "react-redux";

import { ANALYTICS_EVENT_NAMES } from "utils/analytics";
import Buttons from "components/Buttons";
import { Colors } from "colors";
import { FONTS_SIZES } from "fonts";
import ImageView from "../src/image";
import { Images } from "assets";
import ListView from "components/ListView";
import OrderHistoryCard from "components/checkout/OrderHistoryCard";
import ParentScrollView from "components/ParentScrollView";
import SideProfileComp from "components/profile/SideProfileComp";
import VText from "components/VText";
import { analytics } from "utils/firebaseConfig";
import { getOrderDetails } from "appRedux/reducers/orderSlice";
import { logEvent } from "firebase/analytics";
import moment from "moment";
import { showSuccess } from "utils/ToastUtils";
import { t } from "i18next";
import { trackV2 } from "utils/Segment";

const OrderHistoryDetails = ({}) => {
  const [otherProductsList, setOtherProductList] = useState([]);
  const [allOrderDetails, setAllOrderDetails] = useState();
  const [orderDetails, setOrderDetails] = useState();
  const [isLoading, setLoading] = useState(false);
  const profileData = useSelector((state) => state.ProfileReducer.profileData);

  const local = useLocalSearchParams();
  const _scrollRef = useRef();
  const gender = local?.gender || "female";
  const orderId = local?.id || null;
  const productId = local?.productId || null;
  const size = local?.size || null;

  const dispatch = useDispatch();
  const orderStatus = allOrderDetails?.status;

  const isAffiliate =
    (orderDetails?.affiliateBrandName && orderDetails?.affiliateLink) ||
    orderDetails?.customerId == "affiliate"
      ? true
      : false;

  useEffect(() => {
    const eventData = {
      order_id: orderId,
      order_status: orderStatus,
      order_total_value: allOrderDetails?.totalAmount,
    };
    trackV2(ANALYTICS_EVENT_NAMES.ORDER_DETAILS_VIEWED, eventData);
  }, [allOrderDetails?.totalAmount, orderId, orderStatus]);

  useEffect(() => {
    if (orderId && productId && size) {
      setLoading(true);
      dispatch(getOrderDetails({ orderId: orderId }))
        .then((res) => {
          setLoading(false);
          if ([200].includes(res?.payload?.status)) {
            setAllOrderDetails(res?.payload?.data);
            if (
              res?.payload?.data?.products &&
              Array.isArray(res?.payload?.data?.products)
            ) {
              setOrderDetails(
                res?.payload?.data?.products?.find(
                  (o) => o?.id == productId && o?.size == size
                )
              );
              setOtherProductList(
                [...res?.payload?.data?.products]?.filter(
                  (o) => o?.id != productId
                )
              );
            }
          }
        })
        .catch((err) => {
          setLoading(false);
          alert("Error");
          console.log("err", err);
        });
    }
  }, [orderId, productId, size]);

  const onPressCard = (item) => {
    router.push(
      `${gender == "men" ? "/men" : ""}/order-details?id=${
        allOrderDetails?.id
      }&productId=${item?.id}&size=${item?.size}`
    );
    _scrollRef?.current?.scrollTo({
      x: 0,
      y: 0,
      animated: true,
    });
  };

  const renderItem = ({ item }) => {
    return (
      <View style={{}}>
        <OrderHistoryCard
          currentSize={item?.size}
          onPressReturnPolicy={() => {
            if (item?.returnObject?.url && item?.returnObject?.url != "") {
              Linking.openURL(item?.returnObject?.url);
            } else {
            }
          }}
          productDetails={{ ...allOrderDetails, ...item }}
          onPressCard={() => onPressCard(item)}
        />
      </View>
    );
  };

  const ListHeaderComponent = () => {
    const address = allOrderDetails?.address || {};
    const orderDate = moment(allOrderDetails?.orderDate).format("DD/MM/YYYY");
    const orderTime = moment(allOrderDetails?.orderDate).format("hh:mma");
    const deliveryAddress = allOrderDetails?.address || {};
    const billingaddress = allOrderDetails?.paymentAddress || {};

    return (
      <View style={styles.container}>
        <View
          style={[
            styles.paymentStatusView,
            {
              borderBottomWidth: 1,
              borderColor: "rgba(33, 36, 39, 0.16)",
              paddingBottom: spV(24),
            },
          ]}
        >
          {orderDetails?.isPreorder && (
            <>
              <View
                style={{
                  paddingHorizontal: 8,
                  paddingVertical: 6,
                  borderWidth: 1,
                  borderColor: "#21242799",
                  borderRadius: 2,
                  backgroundColor: "#FFFFFF",
                  alignSelf: "flex-start",
                  marginBottom: 8,
                }}
              >
                <VText
                  style={{
                    lineHeight: 8,
                    fontSize: 8,
                    fontWeight: "550",
                    letterSpacing: "3%",
                    color: "#21242799",
                  }}
                >
                  PRE ORDER
                </VText>
              </View>
            </>
          )}
          {allOrderDetails?.inStore && (
            <View>
              <VText
                style={[
                  {
                    fontSize: 17,
                    lineHeight: 20,
                    color: "#333333",
                    textDecorationLine: "underline",
                  },
                ]}
              >
                {"In-store"}
              </VText>
              <VText
                style={[
                  {
                    fontSize: 15,
                    lineHeight: 20,
                    color: "#212427",
                    fontWeight: "350",
                    marginTop: 5,
                  },
                ]}
              >
                {deliveryAddress?.name}
              </VText>
              <VText style={{ paddingTop: 5 }}>
                {`${deliveryAddress?.addressLine1} ${deliveryAddress?.addressLine2} ${deliveryAddress?.city}, ${deliveryAddress?.state} ${deliveryAddress?.pincode}`}
              </VText>
            </View>
          )}
          {!allOrderDetails?.inStore && (
            <View style={{}}>
              <>
                {getOrderHistoryCardView(
                  orderStatus,
                  { ...allOrderDetails, ...orderDetails },
                  isAffiliate
                )}
                {getOrderHistoryCardBottomView(orderStatus)}
              </>
            </View>
          )}
        </View>
        {(orderDetails?.trackingUrl ||
          orderDetails?.trackingCompany ||
          orderDetails?.trackingNumber) && (
          <View style={[styles.paymentStatusView, { paddingBottom: 0 }]}>
            {orderDetails?.trackingCompany && (
              <View style={{ marginBottom: 10 }}>
                <VText
                  text={"Shipped By"}
                  style={{ color: "#21242799", fontSize: 15, lineHeight: 24 }}
                />
                <VText
                  text={orderDetails?.trackingCompany}
                  style={{ color: "#212427", fontSize: 15, lineHeight: 24 }}
                />
              </View>
            )}
            {orderDetails?.trackingNumber && (
              <View style={{ marginBottom: 10 }}>
                <VText
                  text={"Tracking Number"}
                  style={{ color: "#21242799", fontSize: 15, lineHeight: 24 }}
                />
                <VText
                  text={orderDetails?.trackingNumber}
                  style={{ color: "#212427", fontSize: 15, lineHeight: 24 }}
                />
              </View>
            )}
            {orderDetails?.trackingUrl && (
              <View style={{ marginBottom: 10 }}>
                <Buttons
                  imageIcon={Images.TrackUrl}
                  isInverse
                  text={"Track Shipment"}
                  onPress={() => {
                    Linking.openURL(orderDetails?.trackingUrl);
                  }}
                />
              </View>
            )}
          </View>
        )}

        <View style={styles.ordercontainer}>
          <View style={{ paddingVertical: 5 }}>
            <View style={{ flexDirection: "row", alignItems: "center" }}>
              <VText
                style={styles.orderTextGrey}
              >{`Order ID: ${allOrderDetails?.id}`}</VText>
              <TouchableOpacity
                onPress={async () => {
                  await Clipboard.setStringAsync(allOrderDetails?.id);
                  showSuccess("Copied!");
                }}
                style={{ paddingHorizontal: 10 }}
              >
                <ImageView
                  source={Images.copy}
                  resizeMode={ImageView.resizeMode.contain}
                  style={{ height: 15, width: 15 }}
                />
              </TouchableOpacity>
            </View>
            <VText
              style={styles.orderTextBlack}
            >{`Placed on ${orderDate} at ${orderTime}`}</VText>
          </View>
          {!isAffiliate && !allOrderDetails?.inStore && (
            <View style={{ paddingTop: spV(28) }}>
              <VText style={styles.orderTextGrey}>Delivery Address</VText>
              <VText style={styles.orderTextBlack}>{`${address?.name} `}</VText>
              <VText style={styles.orderTextBlack}>{`${address?.type} `}</VText>
              <VText
                style={styles.orderTextBlack}
              >{`${address?.addressLine1} ${address?.addressLine2} ${address?.city}, ${address?.state} ${address?.pincode}`}</VText>
            </View>
          )}
          {!isAffiliate && (
            <View style={{ paddingTop: spV(28) }}>
              <VText style={styles.orderTextGrey}>{"Billing Address"}</VText>
              <VText
                style={styles.orderTextBlack}
              >{`${address?.name} `}</VText>{" "}
              <VText style={styles.orderTextBlack}>{`${address?.type} `}</VText>
              <VText
                style={styles.orderTextBlack}
              >{`${billingaddress?.addressLine1} ${billingaddress?.addressLine2} ${billingaddress?.city}, ${billingaddress?.state} ${billingaddress?.pincode}`}</VText>
            </View>
          )}
        </View>
        <VText style={styles.itemText}>{"Item"}</VText>
        <OrderHistoryCard
          currentSize={orderDetails?.size}
          productDetails={{ ...allOrderDetails, ...orderDetails }}
          onPressReturnPolicy={() => {
            if (
              orderDetails?.returnObject?.url &&
              orderDetails?.returnObject?.url != ""
            ) {
              Linking.openURL(orderDetails?.returnObject?.url);
            } else {
            }
          }}
          cardStyle={{ borderWidth: 0 }}
          onPressCard={() => {}}
          isCallFromOrderDetail={true}
          isPreparing={orderStatus === ORDER_STATUS.PREPARING}
          isDelivered={orderStatus === ORDER_STATUS.DELIVERED}
        />
        <VText
          style={{
            fontSize: fp(16),
            lineHeight: fp(24),
            color: "rgba(33, 36, 39, 1)",
            textAlign: "center",
          }}
        >
          For cancellation, please mail your query at{" "}
        </VText>
        <Pressable
          onPress={() => {
            Linking.openURL("mailto:concierge@vetirapp.com");
          }}
        >
          <VText
            style={{
              fontSize: fp(16),
              lineHeight: fp(24),
              color: "rgba(33, 36, 39, 1)",
              textAlign: "center",
              fontWeight: "550",
              textDecorationLine: "underline",
            }}
          >
            Concierge@vetirapp.com
          </VText>
        </Pressable>

        <View style={styles.priceBreakupContainer}>
          <View style={[styles.rowContainer]}>
            <VText style={styles.boldText}>Order Total</VText>
            <VText style={styles.boldText}>{`$${getFormatedCurrency(
              allOrderDetails?.totalAmount
            )}`}</VText>
          </View>
          <View style={[styles.rowContainer, { paddingTop: 10 }]}>
            <VText style={styles.greyText}>{`SubTotal ${
              orderDetails?.quantity
                ? `(${orderDetails?.quantity} Products)`
                : ""
            }`}</VText>
            <VText style={styles.blackText}>{`$${getFormatedCurrency(
              orderDetails?.totalProductPrice || orderDetails?.productPrice
            )}`}</VText>
          </View>
          <View style={[styles.rowContainer, { paddingTop: 10 }]}>
            <VText style={styles.greyText}>
              {`Shipping Charges (${
                orderDetails?.selectedShippingMethod &&
                orderDetails?.selectedShippingMethod != "null"
                  ? orderDetails?.selectedShippingMethod
                  : "Standard Delivery"
              })`}
            </VText>
            <VText style={styles.blackText}>{`$${getFormatedCurrency(
              allOrderDetails?.deliveryCharge || 0
            )}`}</VText>
          </View>
          <View style={[styles.rowContainer, { paddingTop: 10 }]}>
            <VText style={styles.greyText}>{"Sales Tax"}</VText>
            <VText style={styles.blackText}>{`$${getFormatedCurrency(
              allOrderDetails?.taxAmount || 0
            )}`}</VText>
          </View>
          {allOrderDetails?.couponCode && (
            <View style={[styles.rowContainer, { paddingTop: 10 }]}>
              <VText
                style={styles.greyText}
              >{`Promotion (${allOrderDetails?.couponCode})`}</VText>
              <VText style={styles.blackText}>{`- $${getFormatedCurrency(
                allOrderDetails?.discountAmount || 0
              )}`}</VText>
            </View>
          )}
        </View>
        <View
          style={{
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
            marginTop: spV(16),
            paddingVertical: spV(16),
            paddingBottom: spV(30),
            borderBottomWidth: 1,
            borderColor: "rgba(33, 36, 39, 0.16)",
          }}
        >
          <VText
            style={{
              color: "rgba(33, 36, 39, 1)",
              fontWeight: "550",
              fontSize: fp(16),
              lineHeight: fp(20),
            }}
          >
            {"Updates Sent To:"}
          </VText>
          <VText
            style={{
              color: "rgba(33, 36, 39, 1)",
              fontSize: fp(16),
              lineHeight: fp(20),
            }}
          >
            {profileData?.emailId}
          </VText>
        </View>

        {!isAffiliate && (
          <View
            style={{
              marginTop: 4,
              width: "100%",
              paddingVertical: spV(16),
              backgroundColor: Colors.white,
              marginTop: spV(16),
            }}
          >
            <View
              style={[
                {
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                },
              ]}
            >
              <VText
                style={{
                  color: "rgba(33, 36, 39, 1)",
                  fontWeight: "550",
                  fontSize: fp(16),
                  lineHeight: fp(20),
                }}
              >
                {"Paid By"}
              </VText>
              <View>
                {allOrderDetails?.paymentMethod == "PAYPAL" ? (
                  <Svg
                    width="62"
                    height="17"
                    viewBox="0 0 62 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <G clip-path="url(#clip0_8100_50273)">
                      <Path
                        d="M54.1481 4.7119L52.8349 12.9428C52.83 12.973 52.8317 13.0039 52.8401 13.0334C52.8484 13.0629 52.8631 13.0902 52.8831 13.1134C52.9031 13.1366 52.928 13.1551 52.956 13.1677C52.9839 13.1803 53.0143 13.1867 53.045 13.1863H54.5992C54.654 13.1868 54.7072 13.1677 54.7491 13.1324C54.7911 13.0971 54.8189 13.048 54.8277 12.994L56.1409 4.76317C56.1459 4.73294 56.1441 4.70201 56.1358 4.67254C56.1274 4.64307 56.1127 4.61577 56.0927 4.59257C56.0727 4.56936 56.0478 4.5508 56.0198 4.53819C55.9919 4.52558 55.9615 4.51923 55.9308 4.51958H54.3766C54.3216 4.51849 54.2681 4.53741 54.226 4.5728C54.184 4.60819 54.1563 4.65763 54.1481 4.7119ZM52.4886 7.11386H51.0139C50.9592 7.11332 50.906 7.13241 50.8641 7.16764C50.8223 7.20287 50.7945 7.25191 50.7858 7.30586L50.737 7.60888C50.737 7.60888 49.5917 6.37002 47.5638 7.20725C46.4005 7.6866 45.8421 8.67696 45.6044 9.40251C45.6044 9.40251 44.8503 11.6076 46.556 12.8213C46.556 12.8213 48.1377 13.9886 49.9187 12.7495L49.8879 12.9428C49.8808 12.9882 49.8888 13.0347 49.9106 13.0751C49.9325 13.1156 49.9671 13.1478 50.009 13.1668C50.0368 13.1798 50.0673 13.1863 50.098 13.1863H51.5737C51.6287 13.1874 51.6822 13.1685 51.7242 13.1331C51.7663 13.0977 51.794 13.0483 51.8021 12.994L52.6997 7.35745C52.7047 7.32726 52.7029 7.29634 52.6945 7.26691C52.6861 7.23749 52.6712 7.21031 52.6509 7.18733C52.6309 7.16392 52.606 7.14517 52.578 7.13242C52.5499 7.11967 52.5194 7.11355 52.4886 7.11386ZM50.3187 10.229C50.2611 10.6228 50.0615 10.9821 49.7573 11.2396C49.4518 11.498 49.0629 11.6375 48.6624 11.6324C48.5053 11.6342 48.3489 11.6115 48.1989 11.5651C47.5622 11.3627 47.1989 10.7573 47.3033 10.101C47.3613 9.70733 47.5611 9.34828 47.8653 9.091C48.1706 8.83247 48.5592 8.69253 48.9596 8.69688C49.1167 8.69526 49.2731 8.71818 49.4231 8.7648C50.0637 8.96594 50.4254 9.57231 50.3203 10.2293H50.3187V10.229ZM42.4444 10.3847C43.244 10.3847 44.0175 10.1013 44.6251 9.58602C45.2313 9.07249 45.6327 8.359 45.7563 7.57525C46.0146 5.94488 44.7285 4.52186 42.9053 4.52186H39.9681C39.9133 4.52134 39.8601 4.54046 39.8182 4.57576C39.7763 4.61106 39.7486 4.66018 39.7399 4.71419L38.4264 12.945C38.4192 12.9905 38.4272 13.0369 38.4491 13.0774C38.471 13.1179 38.5055 13.15 38.5475 13.169C38.5756 13.1821 38.6057 13.1886 38.6365 13.1886H40.1917C40.2465 13.1892 40.2997 13.17 40.3415 13.1347C40.3834 13.0994 40.4112 13.0503 40.4198 12.9963L40.8054 10.5793C40.8135 10.525 40.8412 10.4755 40.8832 10.44C40.9253 10.4046 40.9788 10.3856 41.0339 10.3867L42.4444 10.3847ZM43.7452 7.50113C43.6493 8.1039 43.1786 8.54766 42.2781 8.54766H41.1269L41.4764 6.35566H42.6071C43.538 6.35729 43.8411 6.90096 43.7452 7.50276V7.50113Z"
                        fill="#0070E0"
                      />
                      <Path
                        d="M36.6544 7.25292L34.8757 10.226L33.9729 7.2748C33.9588 7.22771 33.9297 7.18647 33.89 7.15731C33.8503 7.12816 33.8022 7.11266 33.7529 7.11317H32.1477C32.1062 7.11261 32.0658 7.12704 32.0341 7.1538C32.0024 7.18057 31.9815 7.21786 31.9752 7.2588C31.9713 7.28595 31.9741 7.31364 31.9834 7.33946L33.601 12.3106L32.1379 14.6531C32.1254 14.6724 32.1171 14.694 32.1133 14.7166C32.1096 14.7392 32.1105 14.7624 32.116 14.7846C32.1215 14.8069 32.1315 14.8278 32.1454 14.846C32.1593 14.8643 32.1768 14.8795 32.1968 14.8908C32.2235 14.9061 32.254 14.914 32.2848 14.9137H34.0138C34.0631 14.9138 34.1117 14.9013 34.1548 14.8773C34.1978 14.8532 34.2339 14.8185 34.2596 14.7765L38.7781 7.37505C38.7945 7.34927 38.8035 7.31952 38.8041 7.28902C38.8048 7.25851 38.797 7.22841 38.7817 7.20199C38.7665 7.17547 38.7444 7.15351 38.7177 7.13841C38.691 7.12331 38.6608 7.11561 38.6302 7.11611H36.9019C36.8523 7.11565 36.8034 7.12802 36.76 7.15199C36.7167 7.17597 36.6803 7.21074 36.6544 7.25292ZM31.2377 7.11317H29.7618C29.7069 7.11265 29.6536 7.13181 29.6116 7.16717C29.5697 7.20252 29.5419 7.25173 29.5333 7.30582L29.4855 7.60852C29.4855 7.60852 28.3392 6.36966 26.3113 7.20688C25.1483 7.68623 24.5896 8.6766 24.3529 9.40215C24.3529 9.40215 23.5981 11.6072 25.3035 12.8209C25.3035 12.8209 26.8855 13.9883 28.6665 12.7491L28.6357 12.9424C28.6285 12.9878 28.6364 13.0343 28.6583 13.0748C28.6802 13.1153 28.7148 13.1475 28.7568 13.1664C28.7847 13.1795 28.8151 13.186 28.8459 13.186H30.3215C30.3763 13.1864 30.4294 13.1672 30.4712 13.1319C30.5131 13.0967 30.5409 13.0476 30.5496 12.9937L31.4475 7.35709C31.4548 7.31162 31.4469 7.26501 31.425 7.22446C31.4032 7.18392 31.3685 7.15169 31.3264 7.13276C31.2985 7.11994 31.2684 7.11326 31.2377 7.11317ZM29.0675 10.2289C29.0094 10.6223 28.8097 10.981 28.5058 11.2382C28.2004 11.4966 27.8119 11.6364 27.4115 11.632C27.2547 11.6338 27.0985 11.6111 26.9487 11.5648C26.3123 11.3623 25.9493 10.7569 26.0537 10.1003C26.1119 9.70579 26.3125 9.34606 26.6177 9.08868C26.9242 8.83017 27.314 8.69089 27.7153 8.69652C27.8724 8.69488 28.0292 8.71774 28.1791 8.76443C28.8131 8.96558 29.1742 9.57162 29.0694 10.2289H29.0675ZM21.1935 10.3844C21.9918 10.3839 22.764 10.1005 23.3722 9.58468C23.9779 9.07116 24.3789 8.35792 24.5022 7.57456C24.7608 5.94452 23.4744 4.5215 21.6518 4.5215H18.7143C18.6595 4.52095 18.6063 4.54002 18.5644 4.57525C18.5225 4.61047 18.4946 4.65952 18.4858 4.7135L17.1765 12.9421C17.1692 12.9875 17.1771 13.0341 17.199 13.0747C17.2208 13.1152 17.2555 13.1475 17.2976 13.1664C17.3254 13.1791 17.3559 13.186 17.3866 13.186H18.9408C18.9957 13.1865 19.049 13.1673 19.0909 13.132C19.1328 13.0966 19.1607 13.0474 19.1693 12.9933L19.5542 10.5764C19.5624 10.5221 19.5901 10.4726 19.6321 10.4373C19.6742 10.4019 19.7277 10.3829 19.7827 10.384L21.1935 10.3844ZM22.4943 7.50043C22.3984 8.10321 21.928 8.54697 21.0275 8.54697H19.8763L20.2253 6.35497H21.3559C22.2871 6.3566 22.5899 6.9006 22.4943 7.50207V7.50043Z"
                        fill="#003087"
                      />
                      <Path
                        d="M11.1454 4.94613C11.1804 3.12866 9.67764 1.73438 7.61119 1.73438H3.33689C3.23729 1.73433 3.14094 1.76976 3.0652 1.8343C2.98946 1.89883 2.93932 1.98823 2.9238 2.08638L1.21119 12.7616C1.20353 12.81 1.20647 12.8595 1.21981 12.9066C1.23314 12.9537 1.25656 12.9974 1.28845 13.0347C1.32034 13.0719 1.35994 13.1018 1.40452 13.1223C1.4491 13.1428 1.49761 13.1535 1.54671 13.1535H4.07895L3.68321 15.6253C3.67555 15.6737 3.67848 15.7231 3.69182 15.7703C3.70516 15.8174 3.72858 15.8611 3.76046 15.8983C3.79235 15.9356 3.83195 15.9655 3.87653 15.986C3.92112 16.0065 3.96963 16.0171 4.01872 16.0171H6.08157C6.18108 16.0171 6.26979 15.9816 6.34573 15.9172C6.42101 15.8526 6.43345 15.7634 6.44917 15.6651L7.05473 12.1112C7.07011 12.0132 7.1202 11.8859 7.19581 11.8212C7.27142 11.7566 7.33755 11.7213 7.43738 11.7213H8.69957C10.7235 11.7213 12.4403 10.2862 12.7542 8.29046C12.9765 6.87397 12.3677 5.58515 11.1454 4.94613Z"
                        fill="#001C64"
                      />
                      <Path
                        d="M4.62763 9.21601L3.99686 13.2056L3.60079 15.7081C3.59318 15.7565 3.59616 15.8059 3.60954 15.853C3.62292 15.9002 3.64638 15.9438 3.67829 15.981C3.71021 16.0182 3.74983 16.0481 3.79443 16.0686C3.83903 16.089 3.88754 16.0996 3.93663 16.0996H6.11994C6.21945 16.0996 6.31568 16.0641 6.39129 15.9995C6.46691 15.935 6.51694 15.8457 6.53238 15.7476L7.10783 12.1104C7.12334 12.0123 7.17344 11.9229 7.24911 11.8584C7.32478 11.7939 7.42105 11.7584 7.52059 11.7584H8.8057C10.8296 11.7584 12.5465 10.2857 12.8607 8.28997C13.0833 6.87348 12.3684 5.58433 11.1461 4.94531C11.1429 5.09617 11.1298 5.2467 11.1065 5.39592C10.7926 7.39103 9.0751 8.86401 7.05186 8.86401H5.0404C4.94082 8.86412 4.84455 8.89966 4.76888 8.96424C4.69322 9.02882 4.64314 9.11788 4.62763 9.21601Z"
                        fill="#0070E0"
                      />
                      <Path
                        d="M3.99572 13.2044H1.45562C1.40653 13.2044 1.35803 13.1938 1.31346 13.1733C1.26889 13.1528 1.22931 13.1229 1.19744 13.0856C1.16558 13.0484 1.1422 13.0047 1.1289 12.9575C1.1156 12.9104 1.11271 12.8609 1.12043 12.8126L2.83303 1.97895C2.84855 1.88086 2.89864 1.79151 2.97431 1.72698C3.04998 1.66246 3.14625 1.62698 3.2458 1.62695H7.6111C9.67755 1.62695 11.1803 3.12703 11.1453 4.94418C10.6311 4.67512 10.0268 4.52132 9.36495 4.52132H5.72567C5.62606 4.52127 5.52971 4.55671 5.45398 4.62124C5.37824 4.68578 5.3281 4.77517 5.31257 4.87332L4.62714 9.21487L3.99539 13.2044H3.99572Z"
                        fill="#003087"
                      />
                    </G>
                    <Defs>
                      <ClipPath id="clip0_8100_50273">
                        <Rect
                          width="61.5385"
                          height="16"
                          fill="white"
                          transform="translate(0.461914 0.974609)"
                        />
                      </ClipPath>
                    </Defs>
                  </Svg>
                ) : (
                  <>
                    <VText
                      style={{
                        fontWeight: "350",
                        fontSize: FONTS_SIZES.s4,
                        color: Colors.black,
                        textTransform: "capitalize",
                      }}
                    >
                      {`${allOrderDetails?.paymentMethod}${
                        allOrderDetails?.cardNumber
                          ? ` ${allOrderDetails?.cardNumber}`
                          : ""
                      }`}
                    </VText>
                  </>
                )}
              </View>
            </View>
          </View>
        )}
        {otherProductsList.length ? (
          <VText
            style={[
              styles.itemText,
              {
                borderBottomWidth: 1,
                borderColor: "rgba(33, 36, 39, 0.3)",
                marginBottom: spV(28),
              },
            ]}
          >
            {"Other items in this order"}
          </VText>
        ) : null}
      </View>
    );
  };

  const renderContent = useCallback(() => {
    if (isLoading) {
      return (
        <View style={styles.loadingContainer}>
          <ActivityIndicator size="large" color={Colors.black} />
        </View>
      );
    }
    return (
      <ListView
        showsVerticalScrollIndicator={false}
        data={otherProductsList}
        scrollEnabled={false}
        contentContainerStyle={{}}
        renderItem={renderItem}
        keyExtractor={(item) => Math.random().toString()}
        ListHeaderComponent={<ListHeaderComponent />}
      />
    );
  }, [isLoading]);

  return (
    <ParentScrollView _scrollRef={_scrollRef}>
      <View style={styles.container}>
        <VText style={styles.header}>Order Details</VText>
        <View style={styles.content}>
          <SideProfileComp gender={gender} selected="Order History" />
          <View style={styles.orderHistorySection}>{renderContent()}</View>
        </View>
      </View>
    </ParentScrollView>
  );
};

export default OrderHistoryDetails;

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: Colors.white,
    paddingTop: spV(32),
  },
  header: {
    textAlign: "center",
    fontSize: fp(28),
    fontFamily: "LibreBodoni",
    fontWeight: "350",
    marginBottom: spV(28),
  },
  content: {
    flex: 1,
    flexDirection: "row",
  },
  menuSection: {
    marginLeft: spH(70),
    width: "20%",
    paddingRight: spH(20),
    borderRightWidth: 1,
    borderRightColor: "#eee",
  },
  orderHistorySection: {
    width: wp(652),
    marginHorizontal: spH(80),
  },
  flexRowCenter: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  ordercontainer: {
    paddingVertical: 5,
    marginTop: hp(3),
    backgroundColor: Colors.white,
  },
  headerContainer: {
    paddingHorizontal: 16,
    backgroundColor: "white",
    paddingVertical: 5,
  },
  orderTextGrey: {
    fontWeight: "350",
    fontSize: fp(16),
    lineHeight: fp(20),
    color: "rgba(33, 36, 39, 0.6)",
  },
  orderTextBlack: {
    fontWeight: "350",
    fontSize: fp(16),
    color: "rgba(33, 36, 39, 1)",
    lineHeight: fp(20),
    marginTop: spV(4),
  },
  deliverText: {
    fontWeight: "350",
    marginTop: hp(12),
    fontSize: FONTS_SIZES.s4,
  },
  btncontainer: {
    padding: 16,
    marginTop: hp(3),
    flexDirection: "row",
    justifyContent: "space-between",
    backgroundColor: Colors.white,
  },
  reOrderBtn: {
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "center",
    width: spH(165),
    height: spV(50),
    borderRadius: hp(8),
    borderWidth: 1,
    borderColor: Colors.greyBorder,
  },
  btnText: {
    fontSize: FONTS_SIZES.s14,
    fontWeight: "550",
    marginLeft: wp(5),
  },
  cardContainer: {
    marginTop: 5,
  },
  icon: {
    height: 24,
    width: 24,
  },
  bottomView: {
    paddingVertical: 16,
    width: "100%",
    backgroundColor: Colors.white,
    paddingHorizontal: 16,
    shadowColor: Colors.black30,
    shadowOffset: {
      width: 0,
      height: -5,
    },
    shadowOpacity: 0.5,
    shadowRadius: 5,
  },
  reorderBtn: {
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    height: spV(40),
    marginTop: spV(0),
    borderRadius: 5,
    backgroundColor: Colors.black,
  },
  boldWhiteText: {
    fontSize: FONTS_SIZES.s14,
    fontWeight: "550",
    color: Colors.white,
  },
  itemText: {
    paddingTop: spV(40),
    fontSize: fp(20),
    lineHeight: fp(33),
    fontWeight: "550",
    paddingBottom: spV(12),
  },
  paymentStatusText: {
    fontSize: FONTS_SIZES.s14,
    fontWeight: "550",
    lineHeight: 24,
  },
  infoTextGrey: {
    fontWeight: "350",
    fontSize: FONTS_SIZES.s4,
    color: Colors.greyText,
  },
  paymentStatusView: {
    justifyContent: "center",
    paddingVertical: 10,
    backgroundColor: Colors.white,
  },
  statusDescription: {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "flex-start",
  },
  overlay: {
    backgroundColor: "rgba(0,0,0,0.2)",
    flex: 1,
    justifyContent: "flex-end",
  },
  bottomSheet: {
    backgroundColor: "white",
    height: 250,
    borderTopLeftRadius: 5,
    borderTopRightRadius: 5,
    marginTop: "auto",
    padding: 16,
  },
  priceBreakupContainer: {
    marginTop: hp(28),
    backgroundColor: Colors.white,
    paddingBottom: hp(20),
    borderBottomWidth: 1,
    borderColor: "rgba(33, 36, 39, 0.16)",
  },
  blackText: {
    fontWeight: "350",
    fontSize: fp(16),
    lineHeight: fp(20),
    color: "rgba(33, 36, 39, 1)",
  },
  boldText: {
    color: "rgba(33, 36, 39, 1)",
    fontWeight: "550",
    fontSize: fp(16),
    lineHeight: fp(20),
  },
  priceBreakupText: {
    color: Colors.black,
    fontWeight: "350",
    marginBottom: 10,
    fontSize: 16,
  },
  greyText: {
    fontWeight: "350",
    fontSize: fp(16),
    lineHeight: fp(20),
    color: Colors.greyText,
  },
  rowContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    flex: 1,
  },
  loadingContainer: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
  },
  emptyText: {
    fontFamily: "JosefinSans",
    fontSize: 20,
    lineHeight: 24,
    fontWeight: "550",
    textAlign: "center",
    marginTop: spV(15),
  },
  emptyContainer: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
  },
});
